var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globalG"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 3,
    fill: "#FF3D00",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-600ms",
    attributeName: "r",
    values: "0;2;2;3;3;3;0;0",
    dur: "1600ms",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-600ms",
    attributeName: "fill-opacity",
    values: "0.125;0.25;0.5;1;1;0;0",
    keyTimes: "0;0.125;0.25;0.375;0.5;0.5;1",
    dur: "1600ms",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 3,
    "transform-origin": "center",
    transform: "rotate(45)",
    fill: "#FF3D00",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-400ms",
    attributeName: "r",
    values: "0;2;2;3;3;3;0;0",
    dur: "1600ms",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-400ms",
    attributeName: "fill-opacity",
    values: "0.125;0.25;0.5;1;1;0;0",
    keyTimes: "0;0.125;0.25;0.375;0.5;0.5;1",
    dur: "1600ms",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 3,
    "transform-origin": "center",
    transform: "rotate(90)",
    fill: "#FF3D00",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-200ms",
    attributeName: "r",
    values: "0;2;2;3;3;3;0;0",
    dur: "1600ms",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-200ms",
    attributeName: "fill-opacity",
    values: "0.125;0.25;0.5;1;1;0;0",
    keyTimes: "0;0.125;0.25;0.375;0.5;0.5;1",
    dur: "1600ms",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 3,
    "transform-origin": "center",
    transform: "rotate(135)",
    fill: "#FF3D00",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "000ms",
    attributeName: "r",
    values: "0;2;2;3;3;3;0;0",
    dur: "1600ms",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "000ms",
    attributeName: "fill-opacity",
    values: "0.125;0.25;0.5;1;1;0;0",
    keyTimes: "0;0.125;0.25;0.375;0.5;0.5;1",
    dur: "1600ms",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 3,
    "transform-origin": "center",
    transform: "rotate(180)",
    fill: "#FF3D00",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "200ms",
    attributeName: "r",
    values: "0;2;2;3;3;3;0;0",
    dur: "1600ms",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "200ms",
    attributeName: "fill-opacity",
    values: "0.125;0.25;0.5;1;1;0;0",
    keyTimes: "0;0.125;0.25;0.375;0.5;0.5;1",
    dur: "1600ms",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 3,
    "transform-origin": "center",
    transform: "rotate(225)",
    fill: "#FF3D00",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "400ms",
    attributeName: "r",
    values: "0;2;2;3;3;3;0;0",
    dur: "1600ms",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "400ms",
    attributeName: "fill-opacity",
    values: "0.125;0.25;0.5;1;1;0;0",
    keyTimes: "0;0.125;0.25;0.375;0.5;0.5;1",
    dur: "1600ms",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 3,
    "transform-origin": "center",
    transform: "rotate(270)",
    fill: "#FF3D00",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "600ms",
    attributeName: "r",
    values: "0;2;2;3;3;3;0;0",
    dur: "1600ms",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "600ms",
    attributeName: "fill-opacity",
    values: "0.125;0.25;0.5;1;1;0;0",
    keyTimes: "0;0.125;0.25;0.375;0.5;0.5;1",
    dur: "1600ms",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 3,
    "transform-origin": "center",
    transform: "rotate(315)",
    fill: "#FF3D00",
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "800ms",
    attributeName: "r",
    values: "0;2;2;3;3;3;0;0",
    dur: "1600ms",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "800ms",
    attributeName: "fill-opacity",
    values: "0.125;0.25;0.5;1;1;0;0",
    keyTimes: "0;0.125;0.25;0.375;0.5;0.5;1",
    dur: "1600ms",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSpinner);
export default __webpack_public_path__ + "static/media/loadingSpinner.8113f74af30986312815babe0f5bcb1f.svg";
export { ForwardRef as ReactComponent };